// Helps us migrate old layouts to use gaps.
export const GAP_IF_UNDEFINED = 30
